import { IRootState } from '../../../store'
import { IPickupAddressState } from '../store/pickupAddress.types'

export const getPickupAddressSelector = (state: IRootState): IPickupAddressState => state.pickupAddress
